import React from 'react';
import { LegalLayout } from '../legal/LegalPages';
import McpConnectPanel from './McpConnectPanel';
import { MCP_PAGE_TITLE, MCP_PITCH } from '../../config/mcp';

// Public, logged-out-reachable page (same pattern as /terms) — the landing page and What's New
// need a link target that works for anonymous visitors, AND server.json's `websiteUrl` points
// here, so the official MCP Registry and Smithery send strangers to this page. That makes it an
// OUTWARD surface: it leads with investor vocabulary (screens, watchlist, market conditions),
// matching the registry description and the server's own `instructions`, never the in-app term
// "smart lists". Only the app's own feature labels keep that term; this page's prose, the tool
// table and the disclaimer all follow the worker.
const McpPage = () => (
  <LegalLayout title={MCP_PAGE_TITLE} effectiveDate={null}>
    {/* Same MCP_PITCH the panel renders in-app, here at body size as the page's lead — so
        intro={null} keeps the panel from printing the sentence a second time. */}
    <p style={{ margin: '0 0 20px', lineHeight: 1.65 }}>{MCP_PITCH}</p>

    <McpConnectPanel variant="full" intro={null} />

    <p style={{ margin: '16px 0 0', fontSize: '13px', color: '#6b7280', lineHeight: 1.6 }}>
      Listed on{' '}
      <a href="https://smithery.ai/servers/info-jwtr/quantape-markets" style={{ color: '#2563eb' }}>Smithery</a>
      {' '}and the{' '}
      <a href="https://registry.modelcontextprotocol.io/v0.1/servers/com.quantape%2Fmarkets" style={{ color: '#2563eb' }}>official MCP Registry</a>
      {' '}as QuantApe Markets.
    </p>

    <h2 style={{ fontSize: '20px', fontWeight: 600, margin: '28px 0 8px' }}>How billing works</h2>
    <p style={{ margin: '0 0 12px', lineHeight: 1.65 }}>
      Every client gets a free daily allowance — by IP address for anonymous connections, or a
      larger allowance tied to your account once you connect with your session token. Beyond the
      daily allowance, each metered call returns an x402 payment challenge settled in USDC.
      Billing currently runs on Base Sepolia, a test network, while the feature is in preview — no
      real funds are involved yet.
    </p>

    <h2 style={{ fontSize: '20px', fontWeight: 600, margin: '28px 0 8px' }}>Disclaimer and payment terms</h2>
    {/* The server's DISCLAIMER_FULL (workers/mcp-smart-lists/src/server.js) plus a web-only
        on-chain-finality sentence — so it is NOT byte-identical. What must track the worker is
        the noun: "Screens", not "Smart lists". */}
    <p style={{ margin: '0 0 12px', lineHeight: 1.65 }}>
      QuantApe data is informational only and not investment advice. Screens, metrics, market
      analyses and recommendations are generated by rules and models from third-party data and may
      be stale, incomplete or wrong — verify before acting. Metered tools charge USDC via x402
      beyond the free daily allowance; tool errors are never charged and there are no refunds for
      data quality. Payments are final once settled on-chain. See our <a href="/terms#mcp">Terms of Service</a>.
    </p>
  </LegalLayout>
);

export default McpPage;
